import {
  Ace2WarrntyItemAction,
  Ace2WarrntyItemActionTypes,
  Ace2WarrntyItemState,
} from "./types";

const initialState: Ace2WarrntyItemState = {
  warrantyId: "",
  claimId: "",
  invoiceURL: "",
  options: {
    claimItemTypes: [],
    materialTypes: [],
    manufacturers: [],
    colors: [],
  },
  showSucessModal: false,
};

export const ace2WarrntyItemReducer = (
  state: Ace2WarrntyItemState = initialState,
  action: Ace2WarrntyItemActionTypes
): Ace2WarrntyItemState => {
  switch (action.type) {
    case Ace2WarrntyItemAction.SET_OPTIONS: {
      return {
        ...state,
        options: action?.payload || {},
      };
    }

    case Ace2WarrntyItemAction.SET_WARRNTYID_CLAIMID: {
      const { warranty_id, claim_id } = action?.payload || {};
      return {
        ...state,
        warrantyId: warranty_id || "",
        claimId: claim_id || "",
      };
    }

    case Ace2WarrntyItemAction.SHOW_SUCCES_MODAL: {
      return {
        ...state,
        showSucessModal: true,
      };
    }

    case Ace2WarrntyItemAction.SET_INVOICE_URL: {
      return {
        ...state,
        invoiceURL: action?.payload,
      };
    }

    case Ace2WarrntyItemAction.HIDE_SUCCES_MODAL: {
      return {
        ...state,
        showSucessModal: false,
      };
    }

    case Ace2WarrntyItemAction.CLEAN_UP: {
      return {
        warrantyId: "",
        claimId: "",
        invoiceURL: "",
        options: {
          claimItemTypes: [],
          materialTypes: [],
          manufacturers: [],
          colors: [],
        },
        showSucessModal: false,
      };
    }

    default:
      return state;
  }
};
